module.exports = __webpack_public_path__ + "static/goboost-logo-42b49c5bc8bf013be2276dfc95ead3b9.png";